export default "__VITE_ASSET__CDn0F3Zs__"